/**
 * @fileoverview GET handler for the "/integrations/direct/cdi/aws-account-id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiAwsAccountId } from "./constants";
import type { IntegrationsDirectCdiAwsAccountIdResult } from "./types";

export const getIntegrationsDirectCdiAwsAccountId = reactQueryFetcherAdapter(
  integrationsDirectCdiAwsAccountId,
  (signal: AbortSignal): Promise<IntegrationsDirectCdiAwsAccountIdResult> => {
    return fetch("/integrations/direct/cdi/aws-account-id", "GET", {}, { signal });
  }
);
